import React, { createContext, useContext, useState } from "react";

const CardImageVisibilityContext = createContext();

export const CardImageVisibilityProvider = ({ children }) => {
  const [showCardImages, setShowCardImages] = useState(() => {
    const saved = localStorage.getItem("showCardImages");
    return saved ? JSON.parse(saved) : true;
  });

  const toggleShowCardImages = () => {
    setShowCardImages((prev) => {
      const next = !prev;
      localStorage.setItem("showCardImages", JSON.stringify(next));
      return next;
    });
  };

  return (
    <CardImageVisibilityContext.Provider
      value={{ showCardImages, toggleShowCardImages }}
    >
      {children}
    </CardImageVisibilityContext.Provider>
  );
};

export const useCardImageVisibility = () => {
  const context = useContext(CardImageVisibilityContext);
  if (context === undefined) {
    throw new Error(
      "useCardImageVisibility must be used within a CardImageVisibilityProvider"
    );
  }
  return context;
};
